import { memo } from 'react'
import { useNavigate } from '@tanstack/react-router'

import View from './PageNotFound.view'

export interface ControllerProps {}

export const Controller = memo(function PageNotFoundController() {
  const navigate = useNavigate()

  return <View onLanding={() => void navigate({ to: '/' })} />
})

Controller.displayName = 'PageNotFound_Controller'
